var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashWhite = function SvgTrashWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 100,
    viewBox: "0 5 30 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xEDcone_fechar_copy",
    "data-name": "\\xEDcone/fechar copy",
    transform: "translate(0.306 0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M8,34a2.012,2.012,0,0,1-1.993-1.834L4.16,10H1A1,1,0,0,1,0,9V7A1,1,0,0,1,1,6h9V2a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2V6h9a1,1,0,0,1,1,1V9a1,1,0,0,1-1,1H27.841L25.992,32.166A2.012,2.012,0,0,1,24,34Zm1.841-4H22.158l1.669-20H8.172ZM14,6h4V4H14Z",
    transform: "translate(-0.306 -0.324)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash_white.8a16cbc4.svg";
export { ForwardRef as ReactComponent };